// extracted by mini-css-extract-plugin
module.exports = {"orb":"Orb_orb___lQtD","large":"Orb_large__2OXLj","filled":"Orb_filled__ExJfM","tilde":"Orb_tilde__1dlMR"};